<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import WootSnackbar from './Snackbar.vue';
import { emitter } from 'shared/helpers/mitt';
import { useI18n } from 'vue-i18n';
import {
  accessProfileNotice,
  isAccessProfileMessage,
} from 'dashboard/helper/accessProfileNotice';

const props = defineProps({
  duration: {
    type: Number,
    default: 2500,
  },
});

const { t } = useI18n();

const snackMessages = ref([]);
const snackbarContainer = ref(null);

const removeSnackbar = key => {
  snackMessages.value = snackMessages.value.filter(item => item.key !== key);
};

const showPopover = () => {
  try {
    const el = snackbarContainer.value;
    if (el?.matches(':popover-open')) {
      el.hidePopover();
    }
    el?.showPopover();
  } catch (e) {
    // ignore
  }
};

const onNewToastMessage = ({ message: originalMessage, action }) => {
  const message = action?.usei18n ? t(originalMessage) : originalMessage;
  if (isAccessProfileMessage(message)) {
    accessProfileNotice.value = { message };
    return;
  }
  const duration = action?.duration || props.duration;

  const key = `${Date.now()}-${snackMessages.value.length}`;
  snackMessages.value.push({
    key,
    message,
    action,
  });

  nextTick(showPopover);

  setTimeout(() => {
    removeSnackbar(key);
  }, duration);
};

onMounted(() => {
  emitter.on('newToastMessage', onNewToastMessage);
});

onUnmounted(() => {
  emitter.off('newToastMessage', onNewToastMessage);
});
</script>

<template>
  <div ref="snackbarContainer" popover="manual" class="acl-snackbar-container">
    <transition-group name="toast-fade" tag="div">
      <WootSnackbar
        v-for="snackMessage in snackMessages"
        :key="snackMessage.key"
        :message="snackMessage.message"
        :action="snackMessage.action"
        @dismiss="removeSnackbar(snackMessage.key)"
      />
    </transition-group>
  </div>
</template>
